import React, {useState,useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import _ from 'lodash'
import {
    gotoNextPage,
    setAudioStatus,
    setAudioEvent,
    setAlert, gotoPreviousPage
} from "../../store/actions/course.action"
import './FooterNav.sass'
import AudioPlayer from "react-h5-audio-player"
import './Audio.scss'
import {STATUS_PAUSED, STATUS_PLAYING, STATUS_FINISHED} from './../../store/utils/audio.status'
import gsap from "gsap"

const FooterNav = () => {
    const dispatch = useDispatch()
    const pageLocked = useSelector((state) => state.course.pageLocked)
    const audioData = useSelector((state) => state.course.audioData)
    const currentPage = useSelector((state) => state.course.currentPage)
    const courseData = useSelector((state) => state.course.courseData)
    const [showAlert, setShowAlert] = useState(false)


    const next = () => {
        dispatch(gotoNextPage())
    }

    const previous = () => {
        console.log("FooterNav previous()")
        console.log("   currentPage: ", currentPage)
        let hasActivity = _.some(currentPage.elements, {"type": "activity"})
        console.log("   hasActivity: ", hasActivity)
        if (hasActivity) {
            dispatch(setAlert(_.find(courseData.alerts,{"id":"previous"})));
        }
        else{
            dispatch(gotoPreviousPage())
        }
    }

    const donePlaying = () => {
        console.log("FooterNav audio donePlaying()")
        dispatch(setAudioStatus(STATUS_FINISHED))
        if (audioData.autoAdvance) {
            dispatch(gotoNextPage())
        }
    }

    const paused = () => {
        console.log("audio paused")
        //gsap.globalTimeline.pause()
        dispatch(setAudioStatus(STATUS_PAUSED))
    }

    const resumed = () => {

        //gsap.globalTimeline.resume()
        //style={audioData.url?{}:{"visibility":"hidden"}}
        dispatch(setAudioStatus(STATUS_PLAYING))
    }

    const seeked = (e) => {
        console.log("FooterNav audio seeked()")
        dispatch(setAudioEvent(e))
    }

    return (
        <div className="footer-nav">
            <div className={'back'}
                 onClick={previous}>
                BACK
            </div>
            {audioData &&
            <AudioPlayer
                layout="horizontal-reverse"
                autoPlay
                autoPlayAfterSrcChange
                showSkipControls={false}
                showJumpControls={true}
                customAdditionalControls={[]}
                customVolumeControls={[]}
                src={audioData.url}
                onEnded={donePlaying}
                onPause={paused}
                onPlay={resumed}
                onSeeked={seeked}
            />
            }

            <div className={pageLocked ? 'hide next' : 'next'}
                 onClick={() => next()}>
                NEXT
            </div>

        </div>
    )
}

export default FooterNav
